import { Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SelectedEntityItem from '~components/data/selectedEntityItem';
import VirtualizedList from '~components/data/virtualizedList';
import VectorImage from '~components/media/vectorImage';
import Key from '~interfaces/key';
import { Dimens } from '~themes';
import { ifNullOrEmpty } from '~utils/stringUtils';

interface Props {
	selectedKeys: Key[];
	onRemoveClicked: (key: Key) => void;
}

const SelectedKeysOverview = ({ selectedKeys, onRemoveClicked }: Props) => {
	const { t } = useTranslation();
	const { palette } = useTheme();
	const shouldVirtualize = selectedKeys.length >= 20;

	return (
		<Stack
			direction='column'
			sx={{
				width: {
					xs: '100%',
					sm: '500px',
				},
			}}
		>
			<Stack direction='row' gap={Dimens.spacingMd}>
				<VectorImage name='icon/key' />
				<Typography variant='label' color={palette.textPrimary.main}>
					{t('key.labels.selectedKeys', { ns: 'entities' })} ({selectedKeys.length})
				</Typography>
			</Stack>
			{shouldVirtualize ?
				<VirtualizedList
					items={selectedKeys}
					getItemKey={(key) => key.id}
					rowHeight={50}
					maxHeight={440}
					overscan={12}
					renderItem={(key) => (
						<SelectedEntityItem
							entityName={key.name}
							entityId={ifNullOrEmpty(key.serialNumber)}
							onRemoveClicked={() => onRemoveClicked(key)}
						/>
					)}
				/>
			:	<Stack direction='column' sx={{ maxHeight: 440, overflowY: 'auto' }}>
					{selectedKeys.map((key) => (
						<SelectedEntityItem
							key={key.id}
							entityName={key.name}
							entityId={ifNullOrEmpty(key.serialNumber)}
							onRemoveClicked={() => onRemoveClicked(key)}
						/>
					))}
				</Stack>
			}
		</Stack>
	);
};

export default SelectedKeysOverview;
